import type { FC } from "react";
import { Box, Typography } from "@mui/material";

interface DashboardStatWidgetProps {
  title: string;
  value: number;
  subtitle?: string;
}

export const DashboardStatWidget: FC<DashboardStatWidgetProps> = ({
  title,
  value,
  subtitle,
}) => (
  <Box className="dashboard-stat-widget">
    <Box className="dashboard-stat-widget__inner">
      <Typography
        component="p"
        variant="inherit"
        className="dashboard-stat-widget__title"
      >
        {title}
      </Typography>
      <Box className="dashboard-stat-widget__value-row">
        <Typography
          component="p"
          variant="inherit"
          className="dashboard-stat-widget__value"
        >
          {value.toLocaleString()}
        </Typography>
      </Box>
      {subtitle ? (
        <Typography
          component="p"
          variant="inherit"
          className="dashboard-stat-widget__subtitle"
        >
          {subtitle}
        </Typography>
      ) : (
        <Box
          aria-hidden
          className="dashboard-stat-widget__subtitle-spacer"
        />
      )}
    </Box>
  </Box>
);
